import { HTTPMethod } from "http-method-enum";
export default function assertIsHTTPMethod(method) {
    if (!Object.values(HTTPMethod).includes(method)) {
        throw new Error(`String "${method}" is not a valid HTTP method.`);
    }
}
